/**
 * @author PoornaChandu
 */
import React, { useState, useEffect, useRef } from 'react';
import Highlighter from 'react-highlight-words';
import { Button, message, Input, Checkbox, DatePicker, Form, Drawer } from 'antd';
import { EditOutlined, CaretLeftOutlined, SearchOutlined } from '@ant-design/icons';
import { connect } from 'react-redux';
import StyledTable from "../../commons/styles/table";
import constants from './constants';
import localStorage from '../../utils/localStorage';
import { translation } from '../../commons/translation';
import {
  getRuleExecutionInfo,
  saveFeedback,
  getfeedBackInfo,
  updateFeedBack,
  getCommunicationList
} from './Apicalls';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';
import { StyledHomepage } from '../../commons/styles/layout';

const { RangePicker } = DatePicker;

const RulesFeedback = (props) => {
  const [tableData, setTableData] = useState([]);
  const [openModel, setOpenModel] = useState(false);
  const [feedBackInfo, setFeedBackInfo] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [editFlag, setEditFlag] = useState(false);
  const [selectedDate, setSelectedDate] = useState({
    startDate: dayjs().subtract(1, 'hour').format('YYYY-MM-DD 00:00'),
    endDate: dayjs().format('YYYY-MM-DD 23:59')
  });
  const [communicationTypes, setCommunicationTypes] = useState([]);
  const [searchText, setSearchText] = useState('');
  const hRef = useRef(null);
  const searchRef = useRef(null);
  const navigate = useNavigate();
  useEffect(() => {
    getRuleHistory([dayjs().format('YYYY-MM-DD 00:00'), dayjs().format('YYYY-MM-DD 23:59')]);
    communicationType();
  }, []);
  const communicationType = async () => {
    let commlist = await getCommunicationList();
    setCommunicationTypes(commlist.data);
  };
  const getRuleHistory = async (date) => {
    try {
      let queryString = props.location.search;
      let ruleId = queryString.split('=')[1];
      if (ruleId) {
        let ruleStatuInfo = await getRuleExecutionInfo(ruleId, date);
        setTableData(ruleStatuInfo.data);
      }
    } catch (error) {
      message.error(`${error.response.data.message}`);
    }
  };
  const handleFeedbackEvents = (e, type) => {
    let updatedFeedBackInfo = { ...feedBackInfo };
    if (type === 'actions') {
      const { translationCache } = props;
      let actionOptions;
      let keys = Object.keys(translationCache);
      let arrConverter = e.map((action) => {
        let data = keys.filter((labels) => {
          return translationCache[labels] === action;
        });
        if (data[0] === undefined) {
          return [action];
        } else {
          return data;
        }
      });
      actionOptions = arrConverter.map((indexedArry) => {
        return indexedArry[0];
      });
      updatedFeedBackInfo['actions'] = actionOptions;
    } else {
      updatedFeedBackInfo['comments'] = e.target.value;
    }
    setFeedBackInfo(updatedFeedBackInfo);
  };
  const handleModelCancel = () => {
    hRef.current.resetFields();
    setOpenModel(false);
  };
  const handleFeedbackSave = async () => {
    const siteId = localStorage.get('currentSite');
    let payload = {
      Action: feedBackInfo.actions,
      Comments: feedBackInfo.comments,
      StatusId: feedBackInfo.Id,
      TagId: feedBackInfo.TagId,
      TimeStamp: feedBackInfo.timeStamp,
      SiteId: siteId
    };
    try {
      if (!editFlag) {
        await saveFeedback(payload);
        setOpenModel(false);
      } else {
        await updateFeedBack(payload);
        setOpenModel(false);
        setFeedBackInfo({});
      }
    } catch (error) {
      message.error(error.response.data.message);
    }
  };
  const handlePagination = (pageNumber) => {
    setCurrentPage(pageNumber.current);
  };
  const onChange = (value) => {
    getRuleHistory(value);
    setSelectedDate({
      startDate: dayjs(value[0]).format('YYYY-MM-DD HH:mm'),
      endDate: dayjs(value[1]).format('YYYY-MM-DD HH:mm')
    });
  };
  const disabledDate = (current) => {
    return current > dayjs().endOf('day');
  };
  const handleSearch = (selectedKeys, confirm) => {
    confirm();
    setSearchText(selectedKeys[0]);
  };
  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    handleSearch([], confirm);
  };
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchRef}
          placeholder={translation(constants.search, props.translationCache)}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}
          
          style={{ width: 90, marginRight: 8 }}
        >
          {translation(constants.search, props.translationCache)}
        </Button>
        <Button
          onClick={() => handleReset(clearFilters, confirm)}
          
          style={{ width: 90 }}
        >
          {translation(constants.Reset, props.translationCache)}
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined, }} />
    ),
    onFilter: (value, record) =>
      record &&
      record[dataIndex] &&
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchRef.current.select());
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    )
  });
  const columns = [
    {
      title: translation(constants.sno, props.translationCache),
      dataIndex: 'RuleId',
      key: 'RuleId',
      render: (text, record, index) => {
        return (
          <span>
            {currentPage === 1 ? currentPage * (index + 1) : (currentPage - 1) * 10 + (index + 1)}
          </span>
        );
      }
    },
    {
      title: translation(constants.tagName, props.translationCache),
      dataIndex: 'ParameterCode',
      ...getColumnSearchProps('ParameterCode')
    },
    {
      title: translation(constants.tagValue, props.translationCache),
      dataIndex: 'ParameterValue',
      ...getColumnSearchProps('ParameterValue')
    },
    {
      title: translation(constants.communicationType, props.translationCache),
      dataIndex: 'Type',
      key: 'Type',
      ...getColumnSearchProps('Type')
    },
    {
      title: translation(constants.exeTime, props.translationCache),
      dataIndex: 'NotificationTime',
      key: 'NotificationTime',
      ...getColumnSearchProps('NotificationTime'),
      render: (text) => <span>{dayjs(text).format('YYYY-MM-DD HH:mm:ss')}</span>
    },
    {
      title: translation(constants.fdBack, props.translationCache),
      key: 'Feedback',
      render: (text, record) => (
        <span>
          <EditOutlined
            onClick={async () => {
              let updatedFeedBackInfo = {
                ...feedBackInfo,
                timeStamp: record.NotificationTime,
                TagId: record.ParameterCode,
                Id: record.Id,
                Type: record.Type,
                actions: [],
                comments: record.comments ? record.comments : ''
              };
              let editFlag = false;
              try {
                let feedBackData = await getfeedBackInfo(record.Id);
                if (feedBackData && feedBackData.data && feedBackData.data.length > 0) {
                  updatedFeedBackInfo.actions = feedBackData.data[0].Action;
                  updatedFeedBackInfo['comments'] = feedBackData.data[0].Comments;
                  editFlag = true;
                }
              } catch (error) {
                console.log(error);
              }
              if (hRef.current) {
                hRef.current.setFieldsValue(updatedFeedBackInfo);
              }
              setOpenModel(true);
              // setSelectedRecord(record);
              setFeedBackInfo(updatedFeedBackInfo);
              setEditFlag(editFlag);
            }}
          />
        </span>
      )
    }
    // Uncomment and modify the following block if needed
    // {
    //   title: translation(constants.rootCause, props.translationCache),
    //   key: 'RootCause',
    //   render: (text, record) => (
    //     <span
    //       onClick={async () => {
    //         const updatedFeedBackInfo = {
    //           timeStamp: record.NotificationTime,
    //           TagId: record.ParameterCode,
    //           Id: record.Id,
    //           actions: [],
    //           comments: ''
    //         };
    //         setFeedBackInfo(updatedFeedBackInfo);
    //         props.history.push(
    //           `/rubus/Rule/RootCause/?Device=${record.Id}&Parameter=${record.ParameterCode}&EndTime=${record.NotificationTime}`
    //         );
    //         try {
    //           let feedBackData = await getfeedBackInfo(record.RuleId);
    //           if (feedBackData.data.length > 0) {
    //             updatedFeedBackInfo.actions = feedBackData.data[0].Action;
    //             updatedFeedBackInfo['comments'] = feedBackData.data[0].Comments;
    //           }
    //         } catch (error) {
    //           message.warn("Can't Fetch Feedback Info");
    //         }
    //       }}
    //     >
    //       <ClusterOutlined />
    //     </span>
    //   )
    // }
  ];
  const formItemLayout = {
    labelCol: { span: 5 },
    wrapperCol: { span: 14 }
  };
  return (
    <StyledHomepage>
        <div>
          <Button
            type="primary"
            onClick={() => {
              navigate('/rubus/RulesList');
            }}
          >
            <CaretLeftOutlined />
            {translation(constants.Go_Back)}
          </Button>
          <div>
            <RangePicker
              showTime={{ format: 'HH:mm' }}
              style={{ width: '300px', float: 'right' }}
              format="YYYY-MM-DD HH:mm"
              value={[dayjs(selectedDate.startDate), dayjs(selectedDate.endDate)]}
              onChange={onChange}
              disabledDate={disabledDate}
              onOk={() => { }}
            />
          </div>
          <StyledTable size="small"
            dataSource={tableData}
            columns={columns}
            onChange={handlePagination}
          />
          <Drawer
            title={editFlag ? 'Update Feedback' : 'Create Feedback'}
            closable
            centered
            width={800}
            open={openModel}
            footer={[
              <Button key="back" onClick={handleModelCancel}>
                {translation(constants.cancel)}
              </Button>,
              <Button
                key="submit"
                type="primary"
                onClick={handleFeedbackSave}
                style={{ fontWeight: 700, marginLeft: '5px' }}
              >
                {editFlag ? translation(constants.update) : translation(constants.save)}
              </Button>
            ]}
            onClose={handleModelCancel}
          >
            <Form {...formItemLayout} ref={hRef} initialValues={feedBackInfo}>
              <Form.Item label={translation(constants.timeStamp)}>
                <Input
                  readOnly
                  value={
                    feedBackInfo && feedBackInfo.timeStamp
                      ? dayjs
                        .utc(feedBackInfo.timeStamp, 'YYYY-MM-DD HH:mm:ss')
                        .format('YYYY-MM-DD HH:mm:ss')
                      : null
                  }
                />
              </Form.Item>
              <Form.Item label={translation(constants.tagName)}>
                <Input readOnly value={feedBackInfo ? feedBackInfo.TagId : null} />
              </Form.Item>
              <Form.Item label={translation(constants.action)}>
                <Checkbox.Group
                  options={
                    communicationTypes && Array.isArray(communicationTypes)
                      ? communicationTypes.map((comm) => {
                        return { label: comm.Name, value: comm.Name };
                      })
                      : []
                  }
                  value={
                    feedBackInfo && feedBackInfo.actions
                      ? Array.isArray(feedBackInfo.actions)
                        ? feedBackInfo.actions
                        : [feedBackInfo.actions]
                      : []
                  }
                  onChange={(e) => {
                    handleFeedbackEvents(e, 'actions');
                  }}
                />
              </Form.Item>
              <Form.Item label={translation(constants.comment)}>
                <Input.TextArea
                  value={feedBackInfo.comments ? feedBackInfo.comments : ''}
                  onChange={(e) => handleFeedbackEvents(e)}
                />
              </Form.Item>
            </Form>
          </Drawer>
        </div>
    </StyledHomepage>
  );
};
const mapStateToProps = (state) => {
  return {
    currentTimeZone: state.LayoutReducer.currentTimeZone,
    translationCache: state.TranslationReducer.translationCache,
  };
};
export default connect(mapStateToProps)(RulesFeedback);
